import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import styles from './style.module.css'

function HistoryRowSkeleton() {
    return (
        <div className={styles.row}>
            <div className={styles.icon}>
                <Loader width={40} height={40} />
            </div>
            <div>
                <Loader width={64} height={20} />
                <div className={styles.loaderLeftInfo}>
                    <Loader width={40} height={16} />
                </div>
            </div>
            <div className={styles.right}>
                <Loader width={100} height={20} />
                <div className={styles.rightBottom}>
                    <Loader width={40} height={16} />
                </div>
            </div>
        </div>
    )
}

export default HistoryRowSkeleton
